class ViewModel {
}

export default <KnockoutLazyPageDefinition>{
    viewModel: ViewModel,
    template: require('./menu.html'),
    componentName: "adminMenu",
    loader: () => Promise.resolve()
};